const TYPES = {
    USER_HISTORY : "USER_HISTORY",
    QRC_HISTORY : "QRC_HISTORY",
    QRCHISTORY_HISTORY : "QRCHISTORY_HISTORY",
    DELIVERY_HISTORY : "DELIVERY_HISTORY",
    REPORT_HISTORY : "REPORT_HISTORY",
    SCANBOX_HISTORY : "SCANBOX_HISTORY",
    EAN_HISTORY:"EAN_HISTORY",
    CASHBACK_HISTORY:"CASHBACK_HISTORY",
    CUSTOERMER_HISTORY:"CUSTOERMER_HISTORY",
    CODESCANNING_HISTORY:"CODESCANNING_HISTORY",
    PRODUCTRETURN_HISTORY:"PRODUCTRETURN_HISTORY",
}

export default TYPES;



// WEBPACK FOOTER //
// ./src/models/searchTypes.js